module.exports = __webpack_public_path__ + "img/solution1.2ce22aa4.jpg";